export default __webpack_public_path__ + "static/lee-aa09f1e5e4c8bd754d90a0d958d0311c.jpg";